module.exports = __webpack_public_path__ + "static/bottomManifesto-32acb22949f9572589f62df786306575.png";